import { z } from "zod";
import { ADMIN_ROLES } from "@/config/constants";

export const signUpSchema = z.object({
	email: z.string().email({
		message: "有効なメールアドレスを入力してください。",
	}),
	role: z.enum(ADMIN_ROLES, {
		message: "有効な権限を選択してください。",
	}),
	department: z.string().optional(),
});

export type SignUpFormValue = z.infer<typeof signUpSchema>;
